<markant-icon-button
  class="drawer-toggle"
  [icon]="icon"
  [filled]="true"
  [colorScheme]="'secondary'"
  (click)="toggleDrawer.emit()"
></markant-icon-button>
